<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <!-- <CIcon name="logo" height="48" alt="Logo"/> -->
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard"> Start </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/b2borders" exact> Zamówienia </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/produkcy" exact> Produkty </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/b2busers" exact> Użytkownicy </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/b2bsalesrepresentatives" exact>
          Handlowcy
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <CHeaderNavItem class="d-md-down-none mx-2">
        <strong>API: {{ mthGetApiurl() | urltoproddevel }}</strong>
        <!-- <CHeaderNavLink>
          <CIcon name="cil-account-logout" title="Wyloguj się"/>
        </CHeaderNavLink> -->
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <!-- <CHeaderNavLink>
          <CIcon name="cil-list"/>
        </CHeaderNavLink> -->
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <!-- <CHeaderNavLink>
          <CIcon name="cil-envelope-open"/>
        </CHeaderNavLink> -->
      </CHeaderNavItem>
      <TheHeaderDropdownAccnt />
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" />
      
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
  methods: {
    mthGetApiurl() {
      return process.env.VUE_APP_API_URL;
    },
  },
};
</script>
